import { UserListAdmin } from './UserListAdmin';
// Import full Profile model. The server now returns complete profile objects for each user,
// so we map them to Profile instances for richer information in the admin dashboard.
import { Profile } from './Profile';

// Paginated Users model for admin user lists
export class PaginatedUsers {
  constructor(data = {}) {
    // If the API returns complete profile data for each user, create a Profile instance.
    // Otherwise, fall back to the legacy UserListAdmin mapping for backward compatibility.
    this.users = (data.users || []).map((u) => {
      // Heuristic: A complete profile usually has either a nested "user" object or flattened id/email fields.
      const hasProfileShape = u && (u.user || (u.id && u.email));
      if (hasProfileShape) {
        return new Profile(u);
      }
      return new UserListAdmin(u);
    });

    // Preserve the raw array for UI that wants the untouched JSON
    this.rawUsers = Array.isArray(data.users) ? data.users : [];
    this.total = data.total || 0;
    this.page = data.page || 1;
    this.totalPages = data.totalPages || 1;
  }
}


